export default __webpack_public_path__ + "static/media/loading_02.8a91fb9c.gif";